import React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../../../utils/css";
import { useNavigate } from "../../../hooks/useNavigate";
import { useDashboard } from "../DashboardProvider/DashboardProvider";
import { useAnalytics } from "../../../components/providers/AnalyticsProvider";
import { ClassCheckinSheetData } from "../DashboardSheetContent/SheetContent";
import { ScheduleItem as ScheduleItemType } from "./useDailySchedule";
interface ScheduleItemProps {
  scheduleItem: ScheduleItemType;
  title: string;
  startTime: Date;
  endTime: Date;
  formattedStartTime?: string;
  formattedEndTime?: string;
  actionLabel?: string;
  link?: string;
  attendanceCount?: number;
}

export const ScheduleItem: React.FC<ScheduleItemProps> = ({
  scheduleItem,
  title,
  formattedStartTime,
  formattedEndTime,
  link,
  attendanceCount,
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const { openSheet } = useDashboard();
  const attendanceText =
    attendanceCount && attendanceCount > 0
      ? ` | ${attendanceCount} attendees`
      : "";

  const handleLinkClick = () => {
    if (scheduleItem.type && scheduleItem.type === "calendarItem") {
      trackEvent("Class Check-in Clicked");
      openSheet("classCheckin", "Check-in", {
        classScheduleItem: scheduleItem,
      } as ClassCheckinSheetData);
    } else {
      navigate(link);
    }
  };
  return (
    <>
      {link && (
        <div
          onClick={handleLinkClick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleLinkClick();
            }
          }}
          role="button"
          tabIndex={0}
          className="tw-block tw-no-underline hover:tw-no-underline"
        >
          <div
            className={cn(
              "tw-w-full tw-bg-white tw-text-left tw-flex tw-items-center tw-justify-between tw-border-gray-200",
              "tw-group tw-rounded-lg tw-border tw-py-4 tw-px-4",
              "tw-min-h-[100px]",
              "tw-transition-all tw-duration-200 tw-ease-in-out",
              "hover:tw-bg-gray-50/50 hover:tw-cursor-pointer",
              "hover:tw-outline tw-outline-gray-100 hover:tw-border-gray-200",
            )}
          >
            <div className="tw-text-left tw-space-y-2">
              <p className="tw-text-base tw-text-gray-900 tw-font-bold">
                {title}
              </p>
              <p className="tw-text-xs tw-text-gray-500">
                {formattedStartTime} - {formattedEndTime} {attendanceText}
              </p>
            </div>
            <div className="tw-flex tw-items-center tw-space-x-2">
              <ChevronRight className="tw-w-5 tw-h-5 tw-text-gray-400" />
            </div>
          </div>
        </div>
      )}
      {!link && (
        <div className="tw-flex tw-justify-between tw-items-center tw-p-3 tw-bg-gray-100 tw-rounded-lg">
          <div className="tw-text-left tw-space-y-2">
            <p className="tw-text-base tw-text-gray-800">{title}</p>
            <p className="tw-text-xs tw-text-gray-500">
              {formattedStartTime} - {formattedEndTime}
            </p>
          </div>
        </div>
      )}
    </>
  );
};
